import React, {useState} from 'react';
import Header from './components/Header';
import Formulario from './components/Formulario';
import Resumen from './components/Resumen';
import Resltado from './components/Resultado';
import Spiner from './components/Spiner';

import styled from '@emotion/styled';

const Contenedor = styled.div`
  max-width: 600px;
  margin: auto;
`;

const ContenedroFormulario = styled.div`
  background-color: #fff;
  padding: 3rem;
`;

function App() {

  const [resumen, guardarResumen] = useState({
    cotizacion: 0,
    datos: {
      marca: '',
      year: '',
      plan: ''
    }
  });

  const [cargando, guardarCargando] = useState(false);
  const {cotizacion, datos} = resumen;
  return (
    <Contenedor>
      <Header
        titulo='Cotizador de seguros'
      ></Header>

      <ContenedroFormulario>
        <Formulario 
          guardarResumen={guardarResumen}
          guardarCargando={guardarCargando}
        />

        {cargando ? <Spiner /> : null}
        

        <Resumen 
          datos={datos}
        />

        {!cargando ? 
        <Resltado 
          cotizacion={cotizacion}
        /> : null}

      </ContenedroFormulario>
    </Contenedor>
  );
}

export default App;
